export const HOTJAR_ID = 2108130; 
export const HOTJAR_SNIPPET_VERSION = 6;